module.exports = __webpack_public_path__ + "static/hub@2x-6774575d5fb5cbd7160df6a60b934661.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/collaboration/hub@2x.jpg
// module id = 2580
// module chunks = 168707334958949